// src/context/DocumentStatusBadge.jsx
// Document indexing status pill. Kept separate from admin/StatusBadge (run
// statuses) so the two taxonomies don't bleed into each other.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLORS, FONT_SANS, RADII, SEMANTIC } from '../constants/theme.js';

const PALETTE = {
  ready:    { bg: SEMANTIC.verde.bg, fg: SEMANTIC.verde.fg },
  indexing: { bg: SEMANTIC.attenzione.bg, fg: SEMANTIC.attenzione.fg },
  failed:   { bg: SEMANTIC.errore.bg,  fg: SEMANTIC.errore.fg },
  stale:    { bg: COLORS.border,      fg: COLORS.textSecondary },
};

export default function DocumentStatusBadge({ status }) {
  const { t } = useTranslation('context');
  const key = (status || '').toLowerCase();
  const palette = PALETTE[key] || { bg: COLORS.border, fg: COLORS.textSecondary };
  // Known statuses get a localized label; unknown statuses fall back to the raw
  // enum (or em-dash) — preserves the prior `label: status` behaviour.
  const label = PALETTE[key] ? t(`status.${key}`) : (status || '—');
  const c = { ...palette, label };
  return (
    <span style={{
      padding: '2px 8px', borderRadius: RADII.controlInner,
      fontSize: '11px', fontWeight: 600,
      background: c.bg, color: c.fg,
      fontFamily: FONT_SANS,
      whiteSpace: 'nowrap',
    }}>
      {c.label}
    </span>
  );
}
